import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "package-update-modal-icon mx-auto mt-2 mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "package-update-modal px-6 py-5 text-center" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          color: "#4CAF50",
          size: "36"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("mdi-check", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        })
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "font-weight-bold mt-5 mx-auto package-update-modal-title" }, " Your subscription has been updated. ", -1 /* CACHED */)),
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "package-update-modal-description mt-5 mb-0" }, " Closing this message starts a 10-minute grace period to save your work before the platform automatically refreshes. ", -1 /* CACHED */)),
      _createVNode(_component_v_btn, {
        block: "",
        variant: "outlined",
        height: "48",
        class: "mt-6 close-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => {$setup.emit('close');})
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Close ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}